import React, { useState } from "react";
import { Badge } from "./ui/badge";
import { X } from "lucide-react";
import { galleryImages } from "../data/mock";

const Gallery = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="gallery" className="py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <Badge className="bg-green-50 text-green-700 border border-green-200 hover:bg-green-50 mb-4">Our Shop</Badge>
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 tracking-tight">Real photos from Hamilton's Smog</h2>
          <p className="text-slate-600 mt-4 text-lg">
            From two Porsches on the same day to modern OBD-II diagnostics — take a look inside the shop that Marin County trusts.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {galleryImages.map((img, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              className={`group relative rounded-2xl overflow-hidden border border-slate-200 shadow-sm hover:shadow-xl transition-all duration-300 ${
                i === 0 ? "md:col-span-2 md:row-span-2 aspect-[4/5] md:aspect-square" : "aspect-square"
              }`}
            >
              <img
                src={img.url}
                alt={img.caption}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 via-slate-950/10 to-transparent" />
              <div className="absolute top-3 left-3">
                <span className="text-[10px] uppercase tracking-widest font-black text-white bg-green-600 rounded-full px-3 py-1">
                  {img.tag}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 text-left">
                <p className="text-white font-bold text-sm md:text-base leading-tight">{img.caption}</p>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {active !== null && (
        <div
          className="fixed inset-0 z-50 bg-black/90 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setActive(null)}
        >
          <button
            onClick={() => setActive(null)}
            className="absolute top-4 right-4 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 grid place-items-center text-white"
            aria-label="Close"
          >
            <X className="w-6 h-6" />
          </button>
          <div className="max-w-6xl w-full" onClick={(e) => e.stopPropagation()}>
            <img
              src={galleryImages[active].url}
              alt={galleryImages[active].caption}
              className="w-full max-h-[85vh] object-contain rounded-lg"
            />
            <p className="text-center text-white font-semibold mt-4">{galleryImages[active].caption}</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
